(() => {
  'use strict';
  const root = document.querySelector('[data-ms-fabric-library]');
  const source = document.querySelector('[data-ms-r10-use-map]');
  if (!root || !source) return;

  let records = [];
  try { records = JSON.parse(source.textContent || '[]'); } catch (_) { return; }

  const canonicalUses = ['Everyday Dressmaking','Wedding & Bridal','Sleepwear & Loungewear','Scarves & Accessories','Bedding & Home Textiles'];
  const handleize = (value) => String(value || '').trim().toLowerCase().replace(/&/g,' and ').replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');
  const numericToken = (value) => {
    const n = Number(value);
    return Number.isFinite(n) ? String(Number.isInteger(n) ? n : n) : '';
  };
  const useMap = new Map(records.map((record) => [String(record.handle || ''), record]));

  root.querySelectorAll('[data-ms-library-card]').forEach((card) => {
    const link = card.querySelector('a[href*="/products/"]');
    const match = link?.getAttribute('href')?.match(/\/products\/([^?#/]+)/);
    if (!match) return;
    const record = useMap.get(match[1]) || {};
    const uses = Array.isArray(record.uses) ? record.uses : [];
    const tokens = `|${uses.map(handleize).filter(Boolean).join('|')}|`;
    card.dataset.endUse = tokens === '||' ? '|' : tokens;
    card.dataset.width = numericToken(record.width);
    card.dataset.customisable = record.customisable ? 'yes' : 'no';
    card.dataset.search = `${card.dataset.search || ''} ${uses.join(' ')} ${card.dataset.width ? `${card.dataset.width} cm` : ''} ${record.customisable ? 'customisable custom color lab dip' : ''}`.trim();
  });

  const endUsePanel = root.querySelector('[data-ms-filter-group="end-use"] .ms-fl-filter-group__panel');
  if (endUsePanel) {
    const available = new Set();
    records.forEach((record) => (record.uses || []).forEach((use) => available.add(use)));
    endUsePanel.replaceChildren();
    canonicalUses.filter((use) => available.has(use)).forEach((use) => {
      const label = document.createElement('label'); label.className = 'ms-fl-filter-option';
      const input = document.createElement('input'); input.type = 'checkbox'; input.value = handleize(use); input.dataset.msFilterInput = ''; input.dataset.group = 'end-use'; input.dataset.field = 'end-use'; input.dataset.label = use;
      const text = document.createElement('span'); text.textContent = use;
      const count = document.createElement('small'); count.dataset.msOptionCount = '';
      label.append(input,text,count); endUsePanel.append(label);
    });
  }

  const morePanel = root.querySelector('[data-ms-filter-more] .ms-fl-filter-more__panel');
  if (!morePanel) return;
  const makeFieldset = (group,labelText,options) => {
    const fieldset = document.createElement('fieldset'); fieldset.className='ms-fl-filter-secondary'; fieldset.dataset.msFilterGroup=group;
    const legend = document.createElement('legend'); legend.textContent=labelText;
    const box = document.createElement('div');
    options.forEach(({value,label}) => {
      const row=document.createElement('label'); row.className='ms-fl-filter-option';
      const input=document.createElement('input'); input.type='checkbox'; input.value=value; input.dataset.msFilterInput=''; input.dataset.group=group; input.dataset.field=group; input.dataset.label=label;
      const text=document.createElement('span'); text.textContent=label;
      const count=document.createElement('small'); count.dataset.msOptionCount='';
      row.append(input,text,count); box.append(row);
    });
    fieldset.append(legend,box); return fieldset;
  };

  const widths=[...new Set(records.map((r)=>numericToken(r.width)).filter(Boolean))].sort((a,b)=>Number(a)-Number(b));
  if (widths.length) morePanel.prepend(makeFieldset('width','Width',widths.map((value)=>({value,label:`${value} cm`}))));
  const customValues=[...new Set(records.map((r)=>r.customisable ? 'yes' : 'no'))];
  if (customValues.length) morePanel.append(makeFieldset('customisable','Customisable',customValues.map((value)=>({value,label:value==='yes'?'Customisable':'Standard only'}))));
})();
